"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var top_app_bar_1 = require("@material/top-app-bar");
var element_children_1 = require("../util/element-children");
var dom_ready_1 = require("../util/dom-ready");
//@ts-ignore
require("../theme.ts");
var topAppBar = /** @class */ (function (_super) {
    __extends(topAppBar, _super);
    function topAppBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tagNum = new Object();
        _this.other = false;
        _this.onNavigation = function (evt) {
            evt && _this.fire('navigation', { nav: 'navigation', index: _this._findPathAccessKey(evt) });
        };
        _this.onAction = function (evt) {
            evt && _this.fire('action', { act: 'action', index: _this._findPathAccessKey(evt) });
        };
        return _this;
    }
    topAppBar.prototype.beforeUpdate = function () {
        this._setChildrenAttribute();
    };
    topAppBar.prototype.updated = function () {
        // update this.topAppBar, more flexible operation (更新 this.topAppBar 变量，操作更灵活)
        this.topAppBar.destroy();
        this.topAppBar = new top_app_bar_1.MDCTopAppBar(this.shadowRoot.querySelector('.mdc-top-app-bar'));
        // Get the target scrollbar of 'm-top-app-bar' and trigger the animation based on this scrollbar (JSX use) (获取 'm-top-app-bar' 的目标滚动条，根据此滚动条触发动画)
        if (this.props.scrollTarget) { //(JSX 使用)
            this.topAppBar.setScrollTarget(this.props.scrollTarget);
        }
        else { // (原生 js 使用)
            if (this.props.scrollTargetId) {
                var findTarge = document.querySelector('#' + this.props.scrollTargetId);
                findTarge ? this.topAppBar.setScrollTarget(findTarge) : this.topAppBar.setScrollTarget(window);
            }
            else {
                this.topAppBar.setScrollTarget(window);
            }
        }
    };
    topAppBar.prototype.installed = function () {
        var _this = this;
        this.topAppBar = new top_app_bar_1.MDCTopAppBar(this.shadowRoot.querySelector('.mdc-top-app-bar'));
        dom_ready_1.domReady(function () {
            _this._setChildrenAttribute();
            _this.update();
        });
    };
    topAppBar.prototype._setChildrenAttribute = function () {
        var _this = this;
        this.tagNum = new Object();
        this.other = false;
        var children = element_children_1.elementChildren(this);
        children.forEach(function (child) {
            if (child.tagName === 'NAVIGATION' || child.tagName === 'ACTIONITEM') {
                if (typeof _this.tagNum[child.tagName] === 'undefined') {
                    _this.tagNum[child.tagName] = new Array();
                }
                var tagLength = _this.tagNum[child.tagName].length;
                child.setAttribute('slot', child.tagName + tagLength + '');
                _this.tagNum[child.tagName].push(tagLength);
            }
            else {
                child.setAttribute('slot', 'OTHER');
                _this.other = true;
            }
        });
    };
    topAppBar.prototype._findPathAccessKey = function (evt) {
        for (var i = 0; i < evt.path.length; i++)
            if ((evt.path[i].tagName === 'SLOT' || evt.path[i].tagName === 'OMIM') && evt.path[i].accessKey)
                return evt.path[i].accessKey;
        return -1;
    };
    topAppBar.prototype.render = function (props) {
        var _this = this;
        return [
            omi_1.h("header", __assign({}, omi_1.extractClass(props, 'mdc-top-app-bar', {
                'mdc-top-app-bar--fixed': props.fixed || props.bottom,
                'mdc-top-app-bar--dense': props.dense,
                'mdc-top-app-bar--short': props.short || props.shortCollapsed,
                'mdc-top-app-bar--short-collapsed': props.shortCollapsed,
                'mdc-top-app-bar--prominent': props.prominent,
                'm-top-app-bar-bottom': props.bottom
            })),
                omi_1.h("div", { class: 'mdc-top-app-bar__row' },
                    (props.navigations || this.tagNum['NAVIGATION'] || props.heading) &&
                        omi_1.h("section", { class: 'mdc-top-app-bar__section mdc-top-app-bar__section--align-start' },
                            props.navigations ? props.navigations.map(function (item, index) {
                                return omi_1.h("omim", { accessKey: index + '', class: omi_1.classNames('mdc-top-app-bar__navigation-icon', { 'material-icons': !item.text }), onClick: _this.onNavigation }, typeof item.text === 'string' ? item.text : item);
                            }) : (this.tagNum['NAVIGATION'] && this.tagNum['NAVIGATION'].map(function (_, index) {
                                return omi_1.h("slot", { accessKey: index + '', class: 'mdc-top-app-bar__navigation-icon', name: 'NAVIGATION' + index, onClick: _this.onNavigation });
                            })),
                            props.heading && omi_1.h("span", { class: 'mdc-top-app-bar__title' }, props.heading)),
                    (props.actionItems || this.tagNum['ACTIONITEM']) &&
                        omi_1.h("section", { class: 'mdc-top-app-bar__section mdc-top-app-bar__section--align-end' }, props.actionItems ?
                            props.actionItems.map(function (item, index) {
                                return omi_1.h("omim", { accessKey: index + '', class: omi_1.classNames('mdc-top-app-bar__action-item', { 'material-icons': !item.text }), onClick: _this.onAction }, typeof item.text === 'string' ? item.text : item);
                            }) : (this.tagNum['ACTIONITEM'] && this.tagNum['ACTIONITEM'].map(function (_, index) {
                            return omi_1.h("slot", { accessKey: index + '', class: 'mdc-top-app-bar__action-item', name: 'ACTIONITEM' + index, onClick: _this.onAction });
                        }))),
                    this.other === true && omi_1.h("slot", { name: 'OTHER' }))),
            (props.adjust && omi_1.h("div", __assign({}, omi_1.extractClass(props, (props.short || props.shortCollapsed) ? 'mdc-top-app-bar--short-fixed-adjust' :
                (props.dense && props.prominent) ? 'mdc-top-app-bar--dense-prominent-fixed-adjust' :
                    props.dense ? 'mdc-top-app-bar--dense-fixed-adjust' :
                        props.prominent ? 'mdc-top-app-bar--prominent-fixed-adjust' : 'mdc-top-app-bar--fixed-adjust'))))
        ];
    };
    topAppBar.css = css;
    topAppBar.propTypes = {
        heading: String,
        short: Boolean,
        shortCollapsed: Boolean,
        prominent: Boolean,
        dense: Boolean,
        fixed: Boolean,
        adjust: Boolean,
        bottom: Boolean,
        navigations: Object,
        actionItems: Object,
        scrollTarget: EventTarget,
        scrollTargetId: String
    };
    topAppBar = __decorate([
        omi_1.tag('m-top-app-bar')
    ], topAppBar);
    return topAppBar;
}(omi_1.WeElement));
exports.default = topAppBar;
